<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="wallsPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panels"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panels" multiple color="#fff">
      <v-expansion-panel class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panels.includes(0)" icon="fa-solid fa-plus" />
          <v-icon v-if="panels.includes(0)" icon="fa-solid fa-minus" />
          <h3>Wall Conditions</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-form v-model="valid" ref="inspectionWallsForm">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="6">
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Overall_Condition_Rating"
                  label="WL.30 Overall Condition Rating"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.strRating"
                ></LabelSelect>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Overall Wall Notes"
                  id="field_Overall_Wall_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.OVERALL_WALL"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :singleLine="false"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Overall Wall Notes"
                  id="field_Overall_Wall_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.OVERALL_WALL"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :singleLine="false"
                  :brkey="wallValues.brkey"
                  :inspectionId="wallValues.inspectionId"
                  :comments="wallValues.inspectionComments"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.OVERALL_WALL)"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12" lg="6" class="pr-lg-3">
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Anchorage_Rating"
                  label="WL.31 Anchorage"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.anchorageCondRate"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Backfill"
                  label="WL.32 Backfill"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.backfillCondRate"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Wall_Rating"
                  label="WL.33 Wall"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.wallCondRate"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Panel_Rating"
                  label="WL.34 Panel"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.panelCondRate"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Post_Rating"
                  label="WL.35 Post"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.postCondRate"
                ></LabelSelect>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="6" class="pl-lg-3">
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Drainage_Rating"
                  label="WL.36 Drainage"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.drainageCondRate"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Foundation_Rating"
                  label="WL.37 Foundation"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.foundCondRate"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Parapets_Rating"
                  label="WL.38 Parapets"
                  :refTable="REFERENCE_TABLE.WALL_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="wallValues.parapetsCondRate"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="false"
                  id="selected_Primary_Backfill_Material"
                  label="WL.21 Primary Backfill Material"
                  :refTable="REFERENCE_TABLE.BACKFILL_MATERIAL"
                  :isEditable="false"
                  v-model="wallValues.backFillMaterial1"
                ></LabelSelect>
                <LabelSelect
                  labelXl="7"
                  labelLg="7"
                  labelMd="6"
                  labelSm="7"
                  selectXl="5"
                  selectLg="5"
                  selectMd="4"
                  selectSm="5"
                  :isRequired="false"
                  id="selected_Secondary_Backfill_Material"
                  label="WL.22 Secondary Backfill Material"
                  :refTable="REFERENCE_TABLE.BACKFILL_MATERIAL"
                  :isEditable="false"
                  v-model="wallValues.backFillMaterial2"
                ></LabelSelect>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="!panels.includes(1)" icon="fa-solid fa-plus" />
          <v-icon v-if="panels.includes(1)" icon="fa-solid fa-minus" />
          <h3>Wall Inspection Notes</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Anchorage"
            id="field_Wall_Anchorage_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_ANCHORAGE"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Anchorage"
            id="field_Wall_Anchorage_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_ANCHORAGE"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL_ANCHORAGE)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Backfill"
            id="field_Wall_Backfill_Damping_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_BACKFLIP_DAMPING"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Backfill"
            id="field_Wall_Backfill_Damping_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_BACKFLIP_DAMPING"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL_BACKFLIP_DAMPING)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Wall"
            id="field_Wall_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Wall"
            id="field_Wall_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Panel"
            id="field_Wall_Panel_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_PANEL"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Panel"
            id="field_Wall_Panel_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_PANEL"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL_PANEL)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Post"
            id="field_Wall_Post_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_POST"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Post"
            id="field_Wall_Post_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_POST"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL_POST)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Drainage"
            id="field_Wall_Drainage_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_PAGE_DRAINAGE"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Drainage"
            id="field_Wall_Drainage_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_PAGE_DRAINAGE"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL_PAGE_DRAINAGE)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Foundation"
            id="field_Wall_Foundation_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_FOUNDATION"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Foundation"
            id="field_Wall_Foundation_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_FOUNDATION"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL_FOUNDATION)"
          />
          <CommentTypeTextField
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            label="Parapets"
            id="field_Wall_Parapets_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_PARAPETS"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            @changesDetected="inspectionStore.setDirtyFlag(true)"
          />
          <ManagementCommentTypeTextField
            v-else
            label="Parapets"
            id="field_Wall_Parapets_Notes"
            :inspectionCommentType="INSPECTION_COMMENTS.WALL_PARAPETS"
            :readonly="!isEditable"
            :counter="commentsMaxLength"
            :maxlength="commentsMaxLength"
            :singleLine="false"
            :brkey="wallValues.brkey"
            :inspectionId="wallValues.inspectionId"
            :comments="wallValues.inspectionComments"
            @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WALL_PARAPETS)"
          />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>
<script>
import { computed, ref, watch, onMounted } from "vue";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { useConfigStore } from "@/stores/config";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { INSPECTION_COMMENTS } from "@/constants/Inspections";
import CommentTypeTextField from "@/components/common/CommentTypeTextField.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { useUserPermissionStore } from "@/stores/userPermission";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { storeToRefs } from "pinia";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { INSPECTION_LINKS_WALLS_PERMISSIONS } from "@/rbac";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { useWallsStore } from "@/components/inspection/store/walls";
import ManagementCommentTypeTextField from "@/components/common/ManagementCommentTypeTextField.vue";
import { SNACKBAR_MARKER, SNACKBAR_MESSAGE_TYPES } from "@/constants/GlobalSnackbar.js";
import { useSnackbarStore } from "@/stores/snackbar";
import { STRUCTURE_SEARCH_MESSAGES } from "@/constants/StructureSearches";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";

export default {
  name: "WallsComponent",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    const configStore = useConfigStore();
    const inspectionStore = useInspectionStore();
    const inspectionLinksStore = useInspectionLinksStore();
    const userPermissionStore = useUserPermissionStore();
    const quickSearchStore = useQuickSearchStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const wallsStore = useWallsStore();
    const allPanels = [0, 1, 2];
    const panels = ref(allPanels);
    const snackbarStore = useSnackbarStore();
    let wallValues = ref({});
    let snackBarId = ref(null);
    let valid = ref(true);
    let inspectionWallsForm = ref(null);
    let resetDirty = ref(false);

    const isEditable = computed(() => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        return hasQuickSearchSucceeded.value && wallValues.value?.brkey && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_WALLS_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(wallValues.value.brkey)
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_WALLS_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(wallValues.value.brkey)
          );
        }
      },
    });

    const readData = async () => {
      wallValues.value = {};
      let isSuccess = false;
      resetDirty.value = true;
      if (props.moduleType == MODULE_TYPES.MANAGEMENT && structureHeader.value?.BRKEY &&
        structureHeader.value.INSPECTIONID) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        isSuccess = await wallsStore.loadDataObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID
        );
        if (isSuccess) {
          wallValues.value = wallsStore.getWallsObject();
        } else {
          showErrorMessage();
        }
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        const structure = computed(() => inspectionStore.selectedInspection);
        await wallsStore.loadDataObject(props.moduleType, null, null, structure.value);
        wallValues.value = wallsStore.getWallsObject();
      }
      resetDirty.value = true;
    };

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    onMounted(async () => {
      await readData();
      await validate();
    });

    async function validate() {
      await inspectionWallsForm.value.validate();
    }

    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panels.value = allPanels;
      } else {
        panels.value = [];
      }
    };

    const saveChanges = async () => {
      const structure = inspectionStore.selectedInspection;
      const isSuccess = await wallsStore.saveData(props.moduleType, wallValues.value, structure);
      if (isSuccess) {
        inspectionLinksStore.isDirty = false;
        if (props.moduleType == MODULE_TYPES.INSPECTION) {
          const structure = computed(() => inspectionStore.selectedInspection);
          await wallsStore.loadDataObject(props.moduleType, null, null, structure.value);
        }
        wallValues.value = wallsStore.getWallsObject();
        // Using this flag to not set the dirty flag in watch
        resetDirty.value = true;
      }
      return isSuccess;
    };

    const cancelChanges = async () => {
      resetDirty.value = true;
      wallValues.value = wallsStore.getWallsObject();
      resetDirty.value = true;
      await validate();
      inspectionLinksStore.isDirty = false;
    };

    const setUpdatedComment = (comment, commentType) => {
      const foundComment = wallValues.value.inspectionComments.find((c) => {
        return c.commentType === commentType;
      });
      if (foundComment) {
        foundComment.notes = comment.notes;
      } else {
        wallValues.value.inspectionComments.push(comment);
      }
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-Walls-Screen", marker: SNACKBAR_MARKER.WALLS };
    };

    const showErrorMessage = () => {
      if ((snackBarId.value === null || snackBarId.value === "") && !quickSearchStore.getErrorMessage()) {
        snackBarId.value = snackbarStore.showMessage({
          displayText: STRUCTURE_SEARCH_MESSAGES.SEARCH_NO_RESULTS,
          messageType: SNACKBAR_MESSAGE_TYPES.ERROR_CUSTOM,
          timeout: 10000,
          callback: () => {
            snackBarId.value = null;
          },
        });
      }
    };

    watch(
      () => [wallValues],
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true }
    );

    return {
      inspectionWallsForm,
      valid,
      validate,
      REFERENCE_TABLE,
      panels,
      isEditable,
      commentsMaxLength,
      INSPECTION_COMMENTS,
      toggleAllPanels,
      wallValues,
      saveChanges,
      cancelChanges,
      setUpdatedComment,
      MODULE_TYPES,
      readData,
      printD491,
      inspectionStore,
    };
  },
  components: {
    LabelSelect,
    CommentTypeTextField,
    ExpandCollapseToggle,
    ManagementCommentTypeTextField,
    ValidationCountsHeader,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

h3 {
  order: 1;
  color: c.$p-white !important;
}

.v-expansion-panel-title__icon {
  order: 0;
}

.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}

.v-label.v-field-label {
  color: c.$p-black !important;
  opacity: 1 !important;
  font-weight: bold !important;
}
</style>
